import store from "@/store/store";
import {
  startLoading,
  stopLoading,
} from "@/store/loaderSlice";

import axios from "axios";

export const setupInterceptors = (instance) => {
  instance.interceptors.request.use(
    (config) => {
      // Global loader only when explicitly enabled
      if (config.showLoader === true) {
        store.dispatch(startLoading());
      }

      const token = localStorage.getItem("token");

      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },

    (error) => {
      if (error.config?.showLoader === true) {
        store.dispatch(stopLoading());
      }

      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      // Stop loader only for requests that started it
      if (response.config?.showLoader === true) {
        store.dispatch(stopLoading());
      }

      return response;
    },

    async (error) => {
      const originalRequest = error.config;

      // Stop loader for the failed request
      if (originalRequest?.showLoader === true) {
        store.dispatch(stopLoading());
      }

      if (!originalRequest) {
        return Promise.reject(error);
      }

      if (
        originalRequest.url?.includes("/auth/logout") ||
        originalRequest.url?.includes("/candidate-auth/logout")
      ) {
        return Promise.reject(
          error.response?.data || error.message
        );
      }

      if (
        originalRequest.url?.includes("/auth/login") ||
        originalRequest.url?.includes("/candidate-auth/login")
      ) {
        return Promise.reject(
          error.response?.data || error.message
        );
      }

      if (originalRequest.url?.includes("/auth/refresh")) {
        localStorage.removeItem("token");
        localStorage.removeItem("auth_user");

        window.location.href = "/login";

        return Promise.reject(
          error.response?.data || error.message
        );
      }

      if (
        error.response?.status === 401 &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;

        try {
          const refreshResponse = await axios.post(
            `${import.meta.env.VITE_API_BASE_URL}/auth/refresh`,
            {},
            {
              withCredentials: true,
            }
          );

          const newAccessToken =
            refreshResponse.data?.data?.accessToken;

          if (!newAccessToken) {
            throw new Error(
              "Access token missing after refresh"
            );
          }

          localStorage.setItem(
            "token",
            newAccessToken
          );

          originalRequest.headers =
            originalRequest.headers || {};

          originalRequest.headers.Authorization =
            `Bearer ${newAccessToken}`;

          // Retry the original request
          return instance(originalRequest);
        } catch (refreshError) {
          console.error(
            "Refresh token failed:",
            refreshError
          );

          localStorage.removeItem("token");
          localStorage.removeItem("auth_user");

          window.location.href = "/login";

          return Promise.reject(refreshError);
        }
      }

      return Promise.reject(
        error.response?.data || error.message
      );
    }
  );
};